module.exports = __webpack_public_path__ + "static/media/output.a82e6270.mp4";